export default store => ({
  isEdit: () => !!store.drivers.router.getQueryParam('edit'),
})
